/* eslint no-new: "off" */

import $ from "jquery";
import {
  removeRequiredAttribute,
  setRequiredAttribute,
} from "./Service/ServiceFunctions";

class RegistrationManager {
  /**
   * contain tnc html objects
   *
   * @property
   * @type {Object}
   */
  $registration;

  /**
   * contains current visible registration index
   *
   * @property currentIndexOfRegistration
   * @type {number}
   */
  currentIndexOfRegistration = 0;

  /**
   * Registration status
   *
   * @property currentIndexOfRegistration
   * @type {boolean}
   */
  registrationStatus = false;

  /**
   * sum of registrations
   *
   * @property indexOfMaxRegistrations
   * @type {number}
   *
   */
  indexOfMaxRegistrations = 0;

  /**
   * authorisation Checkbox
   * @type {object}
   */
  $form = $(".js-contact-form");

  /**
   * authorisation Checkbox
   * @type {object}
   */
  requiredFormFields = "#tncclubauthorisation, #tncclub";

  /**
   * authorisation Checkbox
   * @type {object}
   */
  authorisationIdentifier = $("#tncclubauthorisation");

  /**
   * required field html identifier
   * @type {string}
   */
  requiredIdentifier = "js-required";

  /**
   * Substitute the required field identifier for further processing and adding the required identifier again
   * @type {string}
   */
  substituteForRequiredIdentifier = "js-required-substitute";

  /**
   * Fields not necessary for tnc club identifier
   * @type {string}
   */
  notNecessaryForTncIdentifier = "js-not-necessary-for-tnc-members";

  /**
   * Specific fields for tnc club members identifier
   * @type {string}
   */
  specificForTncIdentifier = "js-specific-for-tnc-members";

  /**
   *  registration button
   * @property $addRegistrationSection
   * @type {object}
   */
  $addRegistrationSection = $(".js-add-tnc-registration");

  /**
   * learning set selection for prime
   * @property $learningSetSelection
   * @type {object}
   */
  $registrationClubTypeWrapper = $(".js-tnc-club-type-wrapper");

  /**
   * learning set selection for prime
   * @property $learningSetSelection
   * @type {object}
   */
  $learningSetWrapper = $(".js-learning-set-wrapper");

  /**
   *  registration applicant is tnc member
   * @type {string}
   */
  registrationApplicantIsTncMember = ".js-registration-tnc-member";

  /**
   * contains delete button identifier
   * @type {string}
   */
  deletButtonID = ".js-registration-delete";

  /**
   * registration class wrapper
   * @type {string}
   */
  registration = ".js-registration";

  /**
   * TNC Club Level selector (basic or premium)
   * @type {string}
   */
  levelSelector = ".js-tnc-club-level";

  /**
   * contains (in live time) the last registration
   */
  $currentRegistration = {};

  /**
   * registration availability
   * @type {boolean}
   */
  registrationAvailability = true;

  /**
   * registrationManager constructor
   */
  constructor() {
    this.$registration = $(".js-registration:not(.js-required-registration)");
    this.indexOfMaxRegistrations = this.$registration.length;

    if ($(this.levelSelector).length) {
      setRequiredAttribute(this.$form, this.levelSelector);
      this.observeLevelSelector();
    }

    // Configure the registration form, if at least one registration is available
    if (this.registrationAvailability) {
      this.registrationButtonOnClick();
      this.activateAllDeleteButtons();
      this.learningSetInit();
      this.activateUserIsTncClubMember();
    }
  }

  /**
   * set availability of registration
   */
  setRegistrationAvailability() {
    this.registrationAvailability =
      this.indexOfMaxRegistrations > this.currentIndexOfRegistration;
  }

  /**
   * initial call to set up the learning-set select
   */
  learningSetInit() {
    // detach from dom because as default no prime is selected
    this.$learningSetWrapper.detach();
  }

  /**
   * show and detach the learning set select box
   * @param {boolean} showSelect
   */
  learningSetHandler(showSelect) {
    if (showSelect === true) {
      this.$learningSetWrapper.insertAfter(this.$registrationClubTypeWrapper);
    } else {
      this.$learningSetWrapper.detach();
    }
  }

  /**
   * set availability of registration
   */
  observeLevelSelector() {
    $(this.levelSelector).change((e) => {
      this.$addRegistrationSection.show();

      if ($(e.currentTarget).val() === "premium") {
        this.learningSetHandler(true);
        setRequiredAttribute(
          this.$learningSetWrapper,
          `.${this.requiredIdentifier}`
        );
      } else {
        this.learningSetHandler(false);

        // set required attribute only for tnc privacy
        setRequiredAttribute(this.$form, this.requiredFormFields);

        // reset all registration form fields if the User change to basic
        this.resetRegistration($(this.registration));
      }
    });
  }

  /**
   * enable on click function
   */
  registrationButtonOnClick() {
    this.$addRegistrationSection.find(".cta-btn--sm").click(() => {
      if (this.registrationStatus === false) {
        this.registrationStatus = true;
        setRequiredAttribute(this.$form, this.requiredFormFields);
      }

      // add new registration
      this.$currentRegistration = $(
        this.$registration[this.currentIndexOfRegistration]
      );
      // reset current registration
      this.resetRegistration(this.$currentRegistration);
      this.$currentRegistration.show();
      setRequiredAttribute(
        this.$currentRegistration,
        `.${this.requiredIdentifier}`
      );
      this.currentIndexOfRegistration += 1;

      // enable delete button on this registration
      this.setVisibilityOnCurrentDeleteButton();

      // hide button
      this.setRegistrationAvailability();
      if (!this.registrationAvailability) {
        this.$addRegistrationSection.hide();
      }
    });
  }

  setVisibilityOnCurrentDeleteButton() {
    // hide all delete buttons
    $(this.deletButtonID).hide();

    // show and enable current delete button
    $(this.$currentRegistration.find(this.deletButtonID)).show();
  }

  activateAllDeleteButtons() {
    $(this.deletButtonID).click(() => {
      // update registration vars)
      this.currentIndexOfRegistration -= 1;
      this.$currentRegistration = $(
        this.$registration[this.currentIndexOfRegistration]
      );

      if (this.currentIndexOfRegistration === 0) {
        removeRequiredAttribute(this.$form, this.requiredFormFields);
        this.authorisationIdentifier.attr("checked", false);
        this.registrationStatus = false;
      }

      // reset current registration
      this.resetRegistration(this.$currentRegistration);
      this.$addRegistrationSection.show();
      this.$currentRegistration.hide();

      // hide all delete buttons enable and show last one
      $(this.deletButtonID).hide();
      $(this.$registration[this.currentIndexOfRegistration - 1])
        .find(this.deletButtonID)
        .show();
    });
  }

  /**
   * Reset given registration
   */
  resetRegistration($registration) {
    // clean all field values
    $registration.find("input").val("");
    $registration.find("select").val("");
    $registration.find("input").removeAttr("checked");

    if ($.isEmptyObject(this.$currentRegistration)) {
      this.$currentRegistration = $(
        this.$registration[this.currentIndexOfRegistration]
      );
    }
    // Reset tnc club field configuration
    const notNecessaryForTncClubFields = this.$currentRegistration.find(
      `.${this.notNecessaryForTncIdentifier}`
    );
    const specificForTncClubFields = this.$currentRegistration.find(
      `.${this.specificForTncIdentifier}`
    );
    this.activateFields(notNecessaryForTncClubFields);
    this.deactivateFields(specificForTncClubFields);
    // Finally remove all required attributes of all fields in current registration
    removeRequiredAttribute(
      this.$currentRegistration,
      `.${this.requiredIdentifier}`
    );
  }

  /**
   * Add an event to indicate that the registration for current user is already an tnc club member
   */
  activateUserIsTncClubMember() {
    // Hide all not necessary fields, if the user is already a tnc club member
    $(this.registrationApplicantIsTncMember).on("change", (e) => {
      // Get registration for current field
      const $registration = $(e.currentTarget).closest(this.registration);
      const notNecessaryForTncClubFields = $registration.find(
        `.${this.notNecessaryForTncIdentifier}`
      );
      const specificForTncClubFields = $registration.find(
        `.${this.specificForTncIdentifier}`
      );
      if (e.currentTarget.checked) {
        // Hide all not necessary fields and show fields specific for tnc members, if the user is already a tnc club member
        this.deactivateFields(notNecessaryForTncClubFields);
        this.activateFields(specificForTncClubFields);
      } else {
        // Show all standard fields and hide fields specific for tnc members, if the user is not a tnc club member
        this.activateFields(notNecessaryForTncClubFields);
        this.deactivateFields(specificForTncClubFields);
      }
    });
  }

  /**
   * Deactivate the given fields
   * @param $fields {Object}
   */
  deactivateFields($fields) {
    $fields.hide();
    $fields
      .find(`.${this.requiredIdentifier}`)
      .addClass(this.substituteForRequiredIdentifier);
    $fields
      .find(`.${this.substituteForRequiredIdentifier}`)
      .removeClass(this.requiredIdentifier);
    removeRequiredAttribute(
      $fields,
      `.${this.substituteForRequiredIdentifier}`
    );
  }

  /**
   * Activate the given fields
   * @param $fields {Object}
   */
  activateFields($fields) {
    $fields.show();
    $fields
      .find(`.${this.substituteForRequiredIdentifier}`)
      .addClass(this.requiredIdentifier);
    $fields
      .find(`.${this.requiredIdentifier}`)
      .removeClass(this.substituteForRequiredIdentifier);
    setRequiredAttribute($fields, `.${this.requiredIdentifier}`);
  }
}

(() => {
  if ($(".js-registration").length) {
    new RegistrationManager();
  }
})();
